module.exports = __webpack_public_path__ + "img/projects.c07e53c4.svg";